<template>
  <div class="year-bar-chart">
    <div ref="chartContainer" :style="{ width: '100%', height: height }"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'YearBarChart',
  props: {
    // 年份数据
    years: {
      type: Array,
      required: true,
      default: () => []
    },
    // 统计数据
    statistics: {
      type: Array,
      required: true,
      default: () => []
    },
    // 图表高度
    height: {
      type: String,
      default: '400px'
    },
    // 图表标题
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    years: {
      handler() {
        this.updateChart()
      },
      deep: true
    },
    statistics: {
      handler() {
        this.updateChart()
      },
      deep: true
    }
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.updateChart()
    },
    updateChart() {
      if (!this.chart) return

      // 计算数据的最大值和最小值，用于颜色渐变
      const maxValue = Math.max(...this.statistics)
      const minValue = Math.min(...this.statistics)

      const option = {
        title: {
          text: this.title,
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.years,
          axisLabel: {
            interval: 0,
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          name: '数量'
        },
        series: [
          {
            name: '统计数量',
            type: 'bar',
            data: this.statistics.map((value, index) => ({
              value: value,
              itemStyle: {
                color: this.getColorByValue(value, minValue, maxValue)
              }
            })),
            barWidth: '40%',
            label: {
              show: true,
              position: 'top',
              formatter: '{c}',
              fontSize: 12,
              color: '#333'
            }
          }
        ]
      }

      this.chart.setOption(option)
    },
    // 根据数值大小计算颜色深浅
    getColorByValue(value, minValue, maxValue) {
      if (maxValue === minValue) {
        return '#409EFF' // 如果所有值相同，使用默认颜色
      }
      
      // 计算颜色深浅比例 (0-1)
      const ratio = (value - minValue) / (maxValue - minValue)
      
      // 使用蓝色系，从浅蓝到深蓝
      const r = Math.round(64 + (ratio * 30)) // 64-94
      const g = Math.round(158 - (ratio * 40)) // 158-118
      const b = Math.round(255 - (ratio * 60)) // 255-195
      
      return `rgb(${r}, ${g}, ${b})`
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.year-bar-chart {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
